export default __webpack_public_path__ + "static/asl-logo-07f5996bc09af486766cc8b6c5d97f82.png";